<section id="sticky-header">
    <div class="wrapper" #errorMessageDiv>
        <div *ngIf="submitted && piecesUsedForm.errors?.invalid"
            class="alert alert-danger alert-dismissible fade show server-error">
            <strong>Error!</strong> {{piecesUsedForm.errors?.invalid}}
            <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
        </div>
        <div *ngIf="isPiecesUsedSubmitted && piecesUsedLotListForm.errors?.invalid"
            class="alert alert-danger alert-dismissible fade show server-error" #errorMessageDiv>
            <strong>Error!</strong> {{piecesUsedLotListForm.errors?.invalid}}
            <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
        </div>
        <div *ngIf="isPiecesUsedSubmitted && isSaved && piecesUsedLotListForm.valid"
            class="alert alert-success alert-dismissible fade show server-error" #successMessageDiv>
            <strong>Success!</strong> Saved Successfully!.
            <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
        </div>
    </div>
</section>

<section class="wrapper edit-page">
    <div class="tracker-info-form">
        <h4 class="form-title">Pieces Used</h4>
        <div class="responsive-grid">
            <form [formGroup]="piecesUsedForm">
                <div class="grid-row clearfix">
                    <div class="col-25">
                        <label for="" class="field-label">
                            <span class="mandatory">*</span>
                            CUSTOMER
                        </label>
                        <div class="relative">
                            <input type="text" class="form-control" formControlName="customer" placeholder="">
                        </div>
                        <div *ngIf="submitted && piecesUsedForm.controls.customer.errors" class="invalid-feedback">
                            <div *ngIf="piecesUsedForm.controls.customer.errors.required">This is required</div>
                        </div>
                    </div>
                    <div class="col-25">
                        <label for="" class="field-label">
                            <span class="mandatory">*</span>
                            STATE
                        </label>
                        <div class="relative">
                            <input type="text" class="form-control" formControlName="state" placeholder="">
                        </div>
                        <div *ngIf="submitted && piecesUsedForm.controls.state.errors" class="invalid-feedback">
                            <div *ngIf="piecesUsedForm.controls.state.errors.required">This is required</div>
                        </div>
                    </div>
                    <div class="col-25">
                        <label for="" class="field-label">
                            <span class="mandatory">*</span>
                            STORE/MODEL
                        </label>
                        <div class="relative">
                            <input type="text" class="form-control" formControlName="store" placeholder="">
                        </div>
                        <div *ngIf="submitted && piecesUsedForm.controls.store.errors" class="invalid-feedback">
                            <div *ngIf="piecesUsedForm.controls.store.errors.required">This is required</div>
                        </div>
                    </div>
                    <div class="col-25">
                        <label for="" class="field-label">
                            <span class="mandatory">*</span>
                            PURCHASE ORDER
                        </label>
                        <div>
                            <input type="text" class="form-control" formControlName="purchaseOrder" placeholder="">
                        </div>
                        <div *ngIf="submitted && piecesUsedForm.controls.purchaseOrder.errors" class="invalid-feedback">
                            <div *ngIf="piecesUsedForm.controls.purchaseOrder.errors.required">This is required</div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>

    <div class="mt-25 align-right pb-20 mb-20">
        <button class="btn btn-secondary ml-10" (click)="cancelPage()">Cancel</button>
        <button class="btn btn-primary ml-10" (click)="fetchLotIds()">Get LOT IDs</button>
    </div>

    <div class="tracker-info mt-25 clearfix" *ngIf="lotList.length > 0 && isLotDataReady">
        <div class="pull-left info-col">
            <h4 class="info-title">Lot IDs</h4>
            <form [formGroup]="piecesUsedLotListForm">
                <ng-container formArrayName="lotNumberPiecesUsedQtyListDtosList">
                    <mat-accordion>

                        <mat-expansion-panel *ngFor="let lotdata of lotList;let rowIndex=index"
                            (opened)="lotdata.panelOpenState = true" (closed)="lotdata.panelOpenState = false">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    {{lotdata?.lotNumber}}
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="responsive-grid">
                                <form [formGroup]="getGroup(rowIndex)">
                                    <div class="tracker-info-form">
                                        <ng-container formArrayName="piecesUsedQtyDtoList">
                                            <ng-container
                                                *ngFor="let size of lotdata?.piecesUsedQtyDtoList; let i=index">
                                                <div [formGroupName]="i" class="grid-row clearfix">
                                                    <div class="col-25">
                                                        <label for="" class="field-label">
                                                            DIM1
                                                        </label>
                                                        <div class="relative">
                                                            <input type="text" class="form-control"
                                                                [ngClass]="{'disabled': true}" [readonly]="true"
                                                                formControlName="dim1" placeholder="">
                                                        </div>
                                                    </div>
                                                    <div class="col-25">
                                                        <label for="" class="field-label">
                                                            DIM2
                                                        </label>
                                                        <div class="relative">
                                                            <input type="text" class="form-control"
                                                                [ngClass]="{'disabled': true}" [readonly]="true"
                                                                formControlName="dim2" placeholder="">
                                                        </div>
                                                    </div>
                                                    <div class="col-20">
                                                        <label for="" class="field-label">
                                                            PIECES USED
                                                        </label>
                                                        <div class="relative">
                                                            <input type="text" class="form-control"
                                                                formControlName="usedQty" placeholder="">
                                                        </div>
                                                        <div class="invalid-feedback">
                                                            <div
                                                                *ngIf="checkSizeDetailsErrors('usedQty', 'pattern', rowIndex, i)">
                                                                Model quantity must be
                                                                numeric</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </ng-container>
                                    </div>
                                </form>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </ng-container>
            </form>
        </div>
        <div class="mt-25 align-right pb-20 mb-20">
            <button class="btn btn-secondary ml-10" (click)="cancelPage()">Cancel</button>
            <button class="btn btn-primary ml-10" (click)="updatePiecesUsed()">Update</button>
        </div>
    </div>
</section>